import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SpinnerCargando from "../SpinnerCargando";
import instanciaAxios from "../../../miscelaneo/instanciaAxios";
import { FaSearch } from "react-icons/fa";

const TablaSucursal = ({ setSucursalSeleccionada, descripcion }) => {
  const [filtro, setFiltro] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const respuesta = await instanciaAxios.get("/miscelaneo/sucursal");
        console.log("Respuesta de la API:", respuesta);
        if (respuesta.status === 200) {
          setSucursales(respuesta.data);
        } else {
          console.error("Datos inválidos o error en el formato recibido.");
          setSucursales([]);
        }
      } catch (error) {
        console.error("Error al cargar las sucursales:", error);
        setSucursales([]);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return sucursales;
    return sucursales.filter((sucursal) =>
      (sucursal.descripcion?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      (sucursal.correo?.toLowerCase() || "").includes(filtro.toLowerCase()) ||
      (sucursal.telefono?.toLowerCase() || "").includes(filtro.toLowerCase())

    );
  }, [sucursales, filtro]);

  const columns = [
    {
      name: "Descripción",
      selector: (row) => row.descripcion,
      sortable: true,
    },
    {
      name: "Correo",
      selector: (row) => row.correo || "—",
      sortable: true,
    },
    {
      name: "Teléfono",
      selector: (row) => row.telefono || "—",
      sortable: true,
    },
  ];

  const handleRowClick = (sucursal) => {
    setSucursalSeleccionada(sucursal); // Puedes pasar el objeto completo o solo el id
  };

  if (cargando) return <SpinnerCargando />;

  if (sucursales.length === 0) {
    return (
      <div className="text-center text-gray-500 mt-5">
        No se encontraron sucursales.
      </div>
    );
  }

  return (
    <DataTable
      title={
        <>
          <h2 className="text-xl font-semibold text-center font-cascadia text-black">
            Sucursales
          </h2>
          <p className="text-sm text-gray-500 text-center">
            {descripcion ? descripcion : null}
          </p>
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      highlightOnHover
      onRowClicked={handleRowClick}
      dense
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar sucursal..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
};

export default TablaSucursal;
